import { CheckBox, CheckBoxProps } from '@toggle/design-system';
import React from 'react';

import styles from './RowSelectionCheckbox.module.scss';

interface RowSelectionCheckboxProps extends Omit<CheckBoxProps, 'label'> {}

export const RowSelectionCheckbox = (props: RowSelectionCheckboxProps) => {
  return <CheckBox className={styles.styledCheckBox} {...props} label="" />;
};
